<form #form [formGroup]="loginForm" (ngSubmit)="loggingIn ? '' : signIn()">
  <h1>{{ "login.sign-in" | transloco }}</h1>

  @if (authExpired) {
  <div class="auth-expired">
    {{ "login.session-timed-out-please-sign-in-again-to-continue" | transloco }}
  </div>
  }
 @if (ssoOnly) {
  <div>
    <label>
      <span class="field-name">{{ "login.username" | transloco }}</span>
      <input
        #username
        [formControlName]="'username'"
        [attr.data-test-ref]="'UserId'"
        placeholder="jane.doe1"
      />
    </label>

    <label>
      <span class="field-name">{{ "login.password" | transloco }}</span>
      <input
        [formControlName]="'password'"
        [attr.data-test-ref]="'pwd'"
        type="password"
        placeholder="Top Secret..."
      />
    </label>

    <button
      class="ui primary background button"
      [attr.data-test-ref]="'loginbtn'"
      type="submit"
      [ngClass]="{ loading: loggingIn }"
    >
      {{ "login.sign-in" | transloco }}
    </button>
  </div>
  }
</form>

@if (msLoginAllowed && ssoOnly) {
  <div class="auth-options">{{ "login.or" | transloco }}</div>
}

@if (msLoginAllowed) {
  <button
    class="auth-signin-with-ad ui primary background button"
    type="submit"
    [ngClass]="{ loading: loginWithMS }"
    (click)="microsoftSignIn()"
  >
    {{ "login.sign-in-with-microsoft" | transloco }}
  </button>
}
